import React from 'react';
import { SpeechToTextLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiTranscriptionConfig } from '@/data/landingConfig/landingAiTranscriptionConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiTranscription } from './schemaObject';

interface Props {}
const AiTranscription: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiTranscription} />
			<SpeechToTextLandingTemplate
				data={landingAiTranscriptionConfig}
				funnelLinkService={GenerateLandingLinkService.funnelSpeechToText()}
			/>
		</>
	);
};

export default AiTranscription;
